import {formatISO, lastDayOfMonth, setDate, sub} from "date-fns";

export const getFetchQueryDataMonth = (monthsEarlier: number, date: Date) => {
    return {
        // First day of month, format yyyy-mm-dd
        date_start: formatISO(sub(setDate(date, 1), {months: monthsEarlier}), {representation: "date"}),
        // Last day of month before date, format yyyy-mm-dd
        date_end: formatISO(lastDayOfMonth(sub(date, {months: monthsEarlier})), {representation: "date"})
    };
};
import {formatISO, lastDayOfMonth, setDate, sub} from "date-fns";

export const getFetchQueryDataMonth = (monthsEarlier: number, date: Date) => {
    return {
        // First day of month, format yyyy-mm-dd
        date_start: formatISO(sub(setDate(date, 1), {months: monthsEarlier}), {representation: "date"}),
        // Last day of month before date, format yyyy-mm-dd
        date_end: formatISO(lastDayOfMonth(sub(date, {months: monthsEarlier})), {representation: "date"})
    };
};
